import React from 'react'
import { Icon } from '@/ui/atoms/Icon'

export type LinkCardProps = {
  className?: string
  title?: string
  header?: string
  text?: string
  hasWhiteBg?: boolean
  showLinkIcon?: boolean
  showArrowIcon?: boolean
  sizes?: 'sm' | 'md' | 'xs'
}

export const LinkCard: React.FC<LinkCardProps> = ({
  className: classNameFromProps,
  title,
  header,
  text,
  hasWhiteBg = true,
  showLinkIcon = true,
  showArrowIcon = true,
  sizes = 'md',
}) => {
  return (
    <div
      className={`no-underline block focus:outline-none focus:ring-2 focus:ring-border-focus rounded-md ${classNameFromProps}`}
    >
      <div
        className={`${
          hasWhiteBg ? 'bg-bg-base' : 'bg-bg-subtle'
        } hover:bg-neutral-95 ${sizes === 'md' ? 'p-card-s' : 'p-3'} rounded-md border border-border-subtle transform transition-all duration-200 ease-in-out`}
      >
        <div className={`flex items-center justify-between`}>
          <div className={`flex gap-2`}>
            <div className="flex items-center">
              {showLinkIcon && <Icon name="link-card-circle" useGradient />}
            </div>
            <div>
              {header && <p className={`text-body-XS-medium text-text-faded`}>{header}</p>}
              {title && (
                <p
                  className={`${sizes === 'md' ? 'text-body-M-semibold' : 'text-body-S-semibold'} text-text-base my-0`}
                >
                  {title}
                </p>
              )}
            </div>
          </div>
          {showArrowIcon && <Icon name="arrow-right-line" className="w-5 h-5" />}
        </div>
        {text && <p className={`text-body-S-regular text-text-faded mt-2`}>{text}</p>}
      </div>
    </div>
  )
}
